import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BID_TYPES = [
  {
    id: 'summary',
    label: 'Summary Bid',
    description: 'Standard bid with full financial breakdown and project details',
    icon: 'FileText',
    color: 'text-accent',
    bg: 'bg-accent/10',
  },
  {
    id: 'simple-proposal',
    label: 'Simple Proposal',
    description: 'A lightweight proposal for straightforward projects',
    icon: 'FileCheck',
    color: 'text-blue-500',
    bg: 'bg-blue-500/10',
  },
  {
    id: 'phased-proposal',
    label: 'Phased Project Proposal',
    description: 'Multi-phase project proposal with staged deliverables',
    icon: 'Layers',
    color: 'text-purple-500',
    bg: 'bg-purple-500/10',
  },
  {
    id: 'detailed-proposal',
    label: 'Detailed Proposal',
    description: 'Comprehensive proposal with full scope and specifications',
    icon: 'ClipboardList',
    color: 'text-orange-500',
    bg: 'bg-orange-500/10',
  },
  {
    id: 'letter',
    label: 'Letter',
    description: 'Formal bid letter for clients and stakeholders',
    icon: 'Mail',
    color: 'text-green-500',
    bg: 'bg-green-500/10',
  },
];

const BidTypeSelectionModal = ({ isOpen, onClose, onSelectType }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card rounded-xl shadow-lg w-full max-w-lg overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Create New Bid</h2>
            <p className="text-sm text-muted-foreground mt-0.5">Select the type of bid you want to create</p>
          </div>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        <div className="p-4 space-y-2">
          {BID_TYPES?.map(type => (
            <button
              key={type?.id}
              onClick={() => onSelectType(type?.id)}
              className="w-full flex items-center gap-4 p-4 rounded-lg border border-border hover:border-accent/50 hover:bg-muted/50 transition-all text-left group"
            >
              <div className={`w-10 h-10 rounded-lg ${type?.bg} flex items-center justify-center flex-shrink-0`}>
                <Icon name={type?.icon} size={20} className={type?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground group-hover:text-accent transition-colors">{type?.label}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{type?.description}</p>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-accent transition-colors flex-shrink-0" />
            </button>
          ))}
        </div>

        <div className="p-4 pt-0">
          <Button variant="outline" className="w-full" onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </div>
  );
};

export default BidTypeSelectionModal;
